export const emptyGrid = {grid: { headerDef: [], rowDef: [], data: [] }}